import { useEffect, useState, useCallback } from "react";
import { adminClient } from "@/lib/apiClient";

// Single source of truth for admin auth state.
// Auth is cookie-based (httpOnly) — the frontend never reads or stores the token.
// We probe the protected /admin/me endpoint to confirm we're signed in.
export function useAdminAuth() {
  const [status, setStatus] = useState("loading"); // loading | authed | guest
  const [username, setUsername] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const res = await adminClient.get("/admin/me");
      setUsername(res.data?.username || null);
      setStatus("authed");
    } catch (e) {
      setUsername(null);
      setStatus("guest");
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (creds) => {
    await adminClient.post("/admin/login", creds);
    await refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await adminClient.post("/admin/logout"); } catch (_) { /* ignore */ }
    setUsername(null);
    setStatus("guest");
  }, []);

  return { status, username, login, logout, refresh };
}
